/**
 * The pasted-data (JSON) box is for development and testing only (Matt, 2026-10-09): users get PDF or
 * photo upload and the manual-entry form. It shows in dev builds, or with ?dev in the address.
 */
export const isDevMode = (search: string, devBuild: boolean): boolean => devBuild || new URLSearchParams(search).has('dev');
